export default __webpack_public_path__ + "static/media/chart ligh.09467a48.svg";